import { Component, OnInit } from "@angular/core";
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { interval, ReplaySubject } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { LoginService } from "./auth/services/login.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})

export class AppComponent implements OnInit {
  readonly destroyer = new ReplaySubject(1);
  // idle time
  idleState = 'Not started.';
  showTimeOutStatus = false;
  constructor(private readonly loginService: LoginService, private readonly idle: Idle, private readonly toastrService: ToastrService) {
    // check for idle user
    this.checkIdleUser();
    // check for token refresh
    this.checkForRefreshToken();
  }

  ngOnInit() {}

  /**
   * check for token validitity after each 3 minutes interval
   */
  checkForRefreshToken(){
    interval(30000).subscribe(res => { // 30,000 (30s)
      const token = JSON.parse(localStorage.getItem('Token'));
      if (token && ((token?.expiresInTime - 300000) <= new Date().getTime())){ // - 5 mins
        console.log('Token is getting expired in some time.');
        // this.toastrService.info("Sending token refresh call");
        this.loginService.refreshToken();
      }
    });
  }

  /**
   * check for idle user
   */
  checkIdleUser(){
    console.log('checkIdleUser: Method');
    this.idle.setIdle(600); // 600s means 10 mins
    // sets a timeout period of 5 seconds. after 10Min+5s of inactivity, the user will be considered timed out.
    this.idle.setTimeout(5);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = "No longer idle.";
      console.log('this.idleState:1 ', this.idleState);
      this.showTimeOutStatus = false;
    });

    this.idle.onTimeout.subscribe(() => {
      this.idleState = "Timed out!";
      this.showTimeOutStatus = true;
      console.log('this.idleState:2 ', this.idleState);
      this.toastrService.info('Session Expired Due to No User Activity!', "Session Expired!");
      this.loginService.logOut(true);
    });

    this.idle.onIdleStart.subscribe(() => {
        this.idleState = "You've gone idle!";
        console.log('this.idleState:3 ', this.idleState);
        this.showTimeOutStatus = false;
      });

    this.idle.onTimeoutWarning.subscribe((countdown: number) => {
        this.idleState = "You will time out in " + countdown + " seconds!";
        console.log('this.idleState:4 ', this.idleState);
        this.showTimeOutStatus = true;
      });

    // start idle user tracking
    this.loginService.startIdleUserTrack();
 }

  ngOnDestroy() {
    this.destroyer.next();
    this.destroyer.complete();
   }

}
